<template>
	<ValidationProvider class="is-block is-relative" :rules="rules" :vid="vid" v-slot="{ errors, valid }">
		<slot></slot>
		<b-field :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors">
			<template #label>
				<span v-html="textLabel(label, rules)"></span>
			</template>
			<b-input :id="`field-${name ? name : slugify(label)}`" v-model="innerValue" :tabindex="tab" :size="size" :icon="icon" :name="name" :type="field" v-bind="$attrs" autocomplete="no" v-on:blur="blur"></b-input>
		</b-field>
	</ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import '@/mixins/generic'

export default {
	components: {
		ValidationProvider
	},
	props: {
		vid: {
			type: [String, Number]
		},
		tab: {
			type: [String, Number],
			default: 1
		},
		label: {
			type: String,
			default: ''
		},
		size: {
			type: String,
			default: ''
		},
		icon: {
			type: String,
			default: ''
		},
		field: {
			type: String,
			default: 'text'
		},
		name: {
			type: [Boolean, String],
			default: false
		},
		rules: {
			type: [Object, String],
			default: ''
		},
		blur: {
			type: Function
		},
		// must be included in props
		value: {
			type: null
		}
	},
	data() {
		return {
			innerValue: ''
		}
	},
	methods: {
		textLabel (label, rules) {
			let required = rules.includes('required')
			return required ? `${label} <span class="required">*</span>` : label
		}
	},
	watch: {
		// Handles internal model changes.
		innerValue(newVal) {
			this.$emit('input', newVal)
		},
		// Handles external model changes.
		value(newVal) {
			this.innerValue = newVal
		}
	},
	created() {
		if (this.value) {
			this.innerValue = this.value
		}
	}
}
</script>
